import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  KpiFactboxSingleMetricVizConfig,
  KpiFactboxSingleMetricVizExternalProps,
  KpiFactboxSingleMetricVizViews,
} from './types';
import { useKpiFactboxSingleMetricConfigToData } from './useConfigToData';
import { singleMetricKpiFactboxViewConfigs } from './views/view-configs';

export interface KpiFactboxSingleMetricVizProps {
  dataConfig: KpiFactboxSingleMetricVizConfig;
  selectedView: KpiFactboxSingleMetricVizViews;
  externalProps: KpiFactboxSingleMetricVizExternalProps;
  persistenceKey: string;
}

export const KpiFactboxSingleMetricViz = (
  props: KpiFactboxSingleMetricVizProps
) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useKpiFactboxSingleMetricConfigToData}
      selectedView={props.selectedView}
      viewConfigs={singleMetricKpiFactboxViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
